module.exports = __webpack_public_path__ + "img/Mousse Cake.a7793553.svg";